import React from 'react'
import HeaderSection from './HeaderSection'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Footer from './Footer'
function LandingPage() {
  return (
    <div>
        <HeaderSection />
        <Section2 />
        <Section3 />
        <Section4 />
        <Footer />
    </div>
    )
}

export default LandingPage